import React, { useState, useEffect } from "react";
import { Form, Row, Col, Modal, Button as But } from "antd";
import CropDown from "../ReportFormGenerator/CropDown/CropDown";
import Button from "../ReportFormGenerator/Button/Button";
import TextBox from "../ReportFormGenerator/TextBox/TextBox";

function SearchModal({
  data,
  modalVisible,
  setModalVisible,
  modalHeader,
  onFinish,
  successButtonText,
  resetButton,
}) {
  const [form] = Form.useForm();

  return (
    <Modal
      centered
      title={
        <h5 style={{ color: "#fff", margin: 0, fontWeight: 600 }}>
          {modalHeader}
        </h5>
      }
      open={modalVisible}
      onCancel={() => setModalVisible(false)}
      footer={null}
      closable={true}
      maskClosable={false}
    >
      <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
        <div className="ThemeForm">
          <Form
            name="ReportForm"
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <CropDown
              url="/cropdown"
              urlData={{ name: "TrgTypes" }}
              form={form}
              name="typ"
              label="Training Type"
              errorMessage="Please Select Training Type"
              required={true}
              defaultValue={data ? data["typ"] : null}
              placeholder="Select Training Type"
              searchable={true}
            />
            <TextBox
              form={form}
              type="input"
              name="subTyp"
              label="Training Sub Type"
              required={true}
              errorMessage="Please Enter Training Sub Type"
              defaultValue={data ? data["subTyp"] : null}
              maxChar={400}
              maxCharErrorMessage="Accepted only 400 Chars"
            />

            <Button
              form={form}
              cancelButtonText={resetButton ? "Reset" : null}
              marginLeft="70px"
              submitButtonText={successButtonText}
            />
          </Form>
        </div>
      </div>
    </Modal>
  );
}

export default SearchModal;
